import React, {useState} from 'react';
import hand from  '../../assets/images/hand1.svg';
import AnimatedCheckbox from "../animatedCheckbox/AnimatedCheckbox";

const DisclaimerModal = ({onClose}) => {
    const [isChecked, setIsChecked] = useState(false);

    const handleCheckboxChange = () => {
        setIsChecked((prev) => !prev);
    };

    return (
        <div className="disclaimer-container">
            <img alt="jace alarm" src={hand} className="disclaimer-icon mb30" />
            <p className="text-white font-normal fs16 text-center"><span className="font-bold">Disclaimer:</span> The alerts provided by the Jace team are AI-generated and based on advanced AI analysis. While the alarms aim to identify potential profitable opportunities, they are not financial advice. We strongly recommend that users conduct their own research and compare these signals with their personal analysis before making any investment decisions. Trading involves risks, and past performance is not indicative of future results. Use the information at your discretion.</p>
            <div className="w100 center">
                <AnimatedCheckbox
                    isChecked={isChecked}
                    onChange={handleCheckboxChange}
                    label="I have read and understood the content of this disclaimer."
                />
            </div>
            <button type="button" disabled={!isChecked} className={`disclaimer-button mt60 ${isChecked ? '' : 'disabledBtn'}`} onClick={onClose}>
                <span className="fs16 text-black">Confirm & Proceed</span>
            </button>
        </div>
    );
}

export default DisclaimerModal;
